import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { StripePaymentCardBrand } from '/@/modules/billing/enums/StripePaymentCardBrand';

export class StripePaymentMethodCard extends BaseModel {
  public brand?: string;
  public expMonth?: number;
  public expYear?: number;
  public last4?: string;

  constructor(model: Partial<StripePaymentMethodCard> = {}) {
    super();

    this.brand = model.brand;
    this.expMonth = model.expMonth;
    this.expYear = model.expYear;
    this.last4 = model.last4;
  }

  get brandLogo(): string | null | undefined {
    return StripePaymentCardBrand.getByKey(this.brand || '')?.logo;
  }
}
